import { memo } from "react"
import styled from "@emotion/styled"
import dayjs from "dayjs"

const DateTextStyled = styled.div`
    font-family: Gilroy;
    font-weight: 500;
    font-size: 12rem;
    line-height: 16rem;
    letter-spacing: 0%;
    color: #69728c;
`

interface ComponentProps {
    timestamp?: number
}

const Component: React.FC<React.PropsWithChildren<ComponentProps>> = (props) => {
    return (
        <DateTextStyled>{dayjs(props.timestamp ?? 0).format("YYYY/MM/DD HH:mm:ss")}</DateTextStyled>
    )
}

export default memo(Component)
